import {
 useMutation
}
from
'@tanstack/react-query';

import toast
from
'react-hot-toast';

import {
 packageServices
}
from
'../services/package.service';



export const
useUploadPackageVideo=
()=>{


 return useMutation({

   mutationFn:
   async(file)=>{

      return await

      packageServices

      .uploadVideo(

         file

      );

   },



   onError:()=>{

      toast.error(

        'Video upload failed'

      );

   }


 });


};